
import API from '../config/api.js'

export const FinancialStatement = {

    info(month) {        
        return API.get(`api/financial-statements/${month}`);
    },

    create(data) {
        return API.post(`api/financial-statements`, data);
    },

    update(id, data) {    
        return API.post(`api/financial-statements/${id}`, data);
    },

}



